import React from 'react';
import { Search, Smartphone, Sparkles, Wrench, Server, CircleDollarSign } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function BenefitsSection() {
  const benefits = [{
    icon: <Search className="w-8 h-8 text-[#c9a84c]" data-id="element-66" />,
    title: 'SEO-Ready Structure',
    desc: 'Built with clean code, fast loading, and proper heading structure so Google can find and rank your business.'
  }, {
    icon: <Smartphone className="w-8 h-8 text-[#c9a84c]" data-id="element-67" />,
    title: 'Mobile Responsive',
    desc: 'Looks perfect on every device. Over 60% of Irish customers browse on mobile — your site will be ready.'
  }, {
    icon: <Sparkles className="w-8 h-8 text-[#c9a84c]" data-id="element-68" />,
    title: 'AI Editable Content',
    desc: 'Update text, images, and sections yourself using simple AI commands. No developer needed after launch.'
  }, {
    icon: <Wrench className="w-8 h-8 text-[#c9a84c]" data-id="element-69" />,
    title: 'Done-For-You Build',
    desc: 'We handle everything from design to deployment. Just send us your content and we do the rest.'
  }, {
    icon: <Server className="w-8 h-8 text-[#c9a84c]" data-id="element-70" />,
    title: 'Hosting + Support Included',
    desc: '1 year of fast hosting and direct WhatsApp support included. No hidden fees or surprise charges.'
  }, {
    icon: <CircleDollarSign className="w-8 h-8 text-[#c9a84c]" data-id="element-71" />,
    title: 'No Monthly Agency Fees',
    desc: 'One-time payment of €249. No retainers, no monthly bills, no lock-in contracts.'
  }];
  return <section id="benefits" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-72">
      <div className="max-w-6xl mx-auto" data-id="element-73">
        <div className="text-center mb-16 reveal" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-75">
            Why Choose Our Website Design Ireland Package
          </h2>
          <div className="h-1 w-20 bg-[#c9a84c] mx-auto rounded-full" data-id="element-76"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-77">
          {benefits.map((benefit, idx) => <div key={idx} className="group relative p-8 rounded-2xl border border-white/[0.06] hover:border-[#c9a84c]/40 transition-all duration-300 reveal" style={{
          backgroundColor: '#0a0a0a',
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-78">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-79"></div>
              <div className="mb-6 bg-[#c9a84c]/10 w-fit p-4 rounded-xl group-hover:bg-[#c9a84c]/15 transition-colors" data-id="element-80">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-81">
                {benefit.title}
              </h3>
              <p className="text-white/60 leading-relaxed text-sm" data-id="element-82">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
      <SectionDivider data-id="element-83" />
    </section>;
}